// Serviceurls.js - API endpoint constants
export const Serviceurls = {
  API_SIGN_IN: "auth/login/",
  GET_MODULES_LIST: "auth/user/linked/modules/",
  MODULES_DATA_GET: "auth/user/token/",
  MODULE_TYPE_LIST_GET: "auth/overall/module/list/",
  AUTOBILLING_GET: "fo/hospital/config/",
  FO_CONFIG_OPDOCTORNAME: "fo/doctor/name/",
  // Histopathology Masters
  HISTOPATHOLOGY_RESULT_TEMPLATE: "histopathology/result/template/",
  HISTOPATHOLOGY_SPECIMEN: "histopathology/specimens/",
  HISTOPATHOLOGY_SAMPLE_DETAILS: "histopathology/sample/details/",
  HISTOPATHOLOGY_SAMPLE_LIST: "histopathology/sample/list/",
  HISTOPATHOLOGY_SAMPLE_COLLECTION: "histopathology/sample-collection/",
  HISTOPATHOLOGY_SAMPLE_COLLECTION_DETAIL: "histopathology/sample-collection/popup/",
  HISTOPATHOLOGY_SAMPLE_COLLECTION_SAVE: "histopathology/sample-collection/save/",
  HISTOPATHOLOGY_SPECIMEN_BARCODE: "histopathology/sample/barcode-print/",
  HISTOPATHOLOGY_SERVICE_CONFIG: "histopathology/service/config/",
  HISTOPATHOLOGY_SPECIMEN_MAP: "histopathology/specimen/map/",
  HISTOPATHOLOGY_OUTSOURCE_CONFIG: "histopathology/outsource/config/",
  HISTOPATHOLOGY_OUTSOURCE: "histopathology/outsource/",
  HISTOPATHOLOGY_OUTSOURCE_SUG: "histopathology/outsource/suggestion/",
  HISTOPATHOLOGY_REPORT_DATA: "histopathology/report/data/",
  HISTOPATHOLOGY_ESIGN_CONFIG: "histopathology/esign/",
  HISTOPATHOLOGY_RESULT_PAGE: "histopathology/result-page/",
  HISTOPATHOLOGY_RESULT_PAGE_SAVE: "histopathology/result-page/save/",
  HISTOPATHOLOGY_RESULT_PAGE_POPUP: "histopathology/result-page/popup/",
  HISTOPATHOLOGY_RESULT_PAGE_AMEND: "histopathology/result-page/amend/",
  HISTOPATHOLOGY_RESULT_PAGE_AMEND_LOG: "histopathology/result-page/amend-log/",
  HISTOPATHOLOGY_RESULT_PAGE_OUTSOURCE_BILLS: "histopathology/result-page/outsource-bills/",
  HISTOPATHOLOGY_RESULT_PAGE_OUTSOURCE_LIST: "histopathology/result-page/outsource-list/",
  HISTOPATHOLOGY_RESULT_PAGE_OUTSOURCE_COMPLETE: "histopathology/result-page/outsource/complete/",
  HISTOPATHOLOGY_RESULT_PAGE_OUTSOURCE_RESULT_UPLOAD: "histopathology/result-page/outsource/result-upload/",
  HISTOPATHOLOGY_RESULT_PAGE_OUTSOURCE_TRANSIT_DETAIL: "histopathology/result-page/outsource/transit-detail/",
  HISTOPATHOLOGY_RESULT_PRINT: "histopathology/result-print/",
  HISTOPATHOLOGY_OUTSOURCE_MAPPING: "histopathology/outsource/mapping/",
  HISTO_ESIGN_ROLEADD: "histopathology/esign/role/",
  HISTO_REFERRAL_DOCTOR: "histopathology/referral/doctor/",
  AWS_URL_GET: "histopathology/aws-s3/url/",
  HISTOPATHOLOGY_S3_PRESIGNED_UPLOAD: "histopathology/s3/presigned-upload/",
  LAB_ESIGN_UPLOAD: "histopathology/aws-s3/url/",
  FODemographicsLayout: "histopathology/demographic/layout/",
  HISTOPATHOLOGY_DEMOGRAPHIC_FIELD_ORDER: "histopathology/demographic/field/order/",
  FO_PATIENT_CREATE: "fo/patient/create/",
  FO_PATIENT_BY_NXT_ID: "fo/patient/by/nxt/id/",
  FO_PATIENT_SEARCH: "fo/patient/search/",
  HISTOPATHOLOGY_BILLING_PATIENT: "histopathology/billing/patient/",
  HISTOPATHOLOGY_BILLING_BILL: "histopathology/billing/bill/",
  HISTOPATHOLOGY_BILLING_BILL_BY_NXT_ID: "histopathology/billing/bill/by-nxt-id/",
  HISTOPATHOLOGY_BILL_PRINT: "histopathology/billing/bill/print/",
  HISTOPATHOLOGY_BILLING_OVERALL_BILLS: "histopathology/billing/reports/overall/",
  HISTOPATHOLOGY_BILLING_CREDIT_BILLS: "histopathology/billing/reports/credit-bill/",
  HISTOPATHOLOGY_BILLING_RECEIPT_BILLS: "histopathology/billing/reports/receipt/",
  HISTOPATHOLOGY_RECEIPT_PRINT: "histopathology/billing/receipt/print/",
  HISTOPATHOLOGY_CREDIT_PAYMENT_RECEIVE: "histopathology/billing/bill/credit-payment/",
  HISTOPATHOLOGY_REPORTS_OUTSOURCE: "histopathology/reports/outsource/",
  HISTOPATHOLOGY_REPORTS_TAT: "histopathology/reports/tat/",
  HISTOPATHOLOGY_REPORTS_PATIENT_WISE: "histopathology/reports/patient-wise/",
  HISTOPATHOLOGY_REPORTS_BILL_MODIFY: "histopathology/reports/bill-modify/",
  HISTOPATHOLOGY_BILLING_BILL_MODIFY: "histopathology/billing/bill/modify/",
  HISTOPATHOLOGY_RESULT_EMAIL_REPORT: "histopathology/result/email-report/",
  HISTOPATHOLOGY_REPORTS_CREDIT_SETTLEMENT: "histopathology/reports/credit-settlement/",
  HISTOPATHOLOGY_CREDIT_SETTLEMENT_CORPORATE: "histopathology/billing/corporate/",
  HISTOPATHOLOGY_CREDIT_SETTLEMENT_CORPORATE_DETAIL: "histopathology/billing/corporate/bills/",
  HISTOPATHOLOGY_CREDIT_SETTLEMENT_CORPORATE_COLLECT: "histopathology/billing/corporate/settlement/",
  FO_CONFIG_CORPORATE: "fo/corporate/detail/",
  HISTOPATHOLOGY_CORPORATE_CONFIG: "histopathology/corporate/config/",
  FO_CONFIG_REF_SOURCE: "fo/referral/source/",
  FO_CONFIG_REF_DOCTOR: "fo/referral/doctor/",
  FO_CONFIG_REF_Config: "fo/referral/staff/",
  FO_INSURANCE_LIST: "fo/insurance/list/",
  LAB_CREATE_PATIENT_DETAILS: "lab/create/patient/profile/",
  RAD_SERVICE_CONFIG: "radiology/service/config/",
  NEW_DEPARTMENT_MASTER: "histopathology/service/config/",
  HISTOPATHOLOGY_CUSTOM_CONFIG: "histopathology/custom/config/",
  HISTOPATHOLOGY_ROLE_ACCESS: "histopathology/role/access/",
  HISTOPATHOLOGY_ROLE_MASTER: "histopathology/user-access/role-master/",
  HISTOPATHOLOGY_USER_ACCESS_ROLE_MAPPING: "histopathology/user-access/role-mapping/",
  HISTOPATHOLOGY_USER_CONFIG: "histopathology/user/config/",
  CUSTOM_CONFIG: "fo/custom-config/",
  LAB_TEST_CONFIG_GET: "lab/test/config/",
};
